import { getMessageFromErrorResponse } from '@netpurpose/utils'
import type { AxiosResponse } from 'axios'
import { EmailNotRecognisedError, GeneralError, NotFoundError, UnprocessableError } from './errors'

type StandardError = UnprocessableError | GeneralError

export const mapError = (response?: AxiosResponse): StandardError => {
  if (!response || !response.status) {
    return new GeneralError()
  }

  switch (response.status) {
    case 404:
      return new NotFoundError(getMessageFromErrorResponse(response))
    case 422:
      return new UnprocessableError(getMessageFromErrorResponse(response))
    default:
      return new GeneralError(response, getMessageFromErrorResponse(response))
  }
}

type UserApiError = StandardError & EmailNotRecognisedError

export const mapUserApiError = (response?: AxiosResponse): UserApiError => {
  if (!response || !response.status) {
    return new GeneralError()
  }

  switch (response.status) {
    case 422:
      return new UnprocessableError(getMessageFromErrorResponse(response))
    case 404:
      return new EmailNotRecognisedError()
    default:
      return new GeneralError(response)
  }
}
